import { noop } from 'lodash'

import { system } from '@eastcoal/common/config/system'

import { AuthStore } from './interface'

export const getAuthStoreInitialValue = (): AuthStore => ({
  // 如果不需要根据权限过滤菜单，可以设置为 true 提前加载路由配置
  loaded: system.api.ignore401,
  logined: false,
  profileId: '',
  dimission: false,
  type: 0,
  administrator: false,
  superAdministrator: false,
  members: [],
  permissions: [],
  roles: [],
  user: {},
  dept: {},
  member: {},
  tokenInfo: {},
  reload: noop
})
